import type { CSSProperties } from "react";

import type {
  CardSkeletonProps,
  CardSkeletonViewModel,
  TableSkeletonProps,
  TableSkeletonViewModel,
} from "./types-skeleton";

/** Índices `0..count-1` para repetir células e linhas; `count` inválido vira 0. */
export function range(count: number): number[] {
  return Array.from({ length: Math.max(0, Math.floor(count)) }, (_, index) => index);
}

/** ViewModel do `TableSkeleton`: índices de linhas e colunas e o `--skeleton-columns` mesclado ao `style` da tela; sem JSX. */
export function useTableSkeleton({
  rows = 5,
  columns = 4,
  size = "normal",
  className,
  style,
  testId,
  ...rest
}: TableSkeletonProps): TableSkeletonViewModel {
  return {
    className,
    style: { ...style, "--skeleton-columns": columns } as CSSProperties,
    size,
    testId,
    rowTestId: testId ? `${testId}-row` : undefined,
    rows: range(rows),
    columns: range(columns),
    rest,
  };
}

/** ViewModel do `CardSkeleton`: linhas de texto (a última é a mais curta) e os `data-testid` derivados; sem JSX. */
export function useCardSkeleton({
  lines = 3,
  withTitle = false,
  className,
  style,
  testId,
  ...rest
}: CardSkeletonProps): CardSkeletonViewModel {
  return {
    className,
    style,
    withTitle,
    testId,
    lineTestId: testId ? `${testId}-line` : undefined,
    lines: range(lines).map((index) => ({ index, last: index === lines - 1 && lines > 1 })),
    rest,
  };
}
